import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import PositionsEmptyStateSvg from '@web/assets/svg/Misc/empty-positions-state.svg';

const SVG_DISPLACEMENT = 37;

const PositionsEmptyState = () => (
  <Column mTop={60} alignItems="center">
    <Column mTop={20} mLeft={SVG_DISPLACEMENT} mBottom={20}>
      <PositionsEmptyStateSvg />
    </Column>
    <Text14 themeColor={ThemeColorType.gray} semiBold>
      {gettext('Looks like you have no positions yet.')}
    </Text14>
    <Text14 themeColor={ThemeColorType.gray} semiBold>
      {gettext('Add positions to be able to use them for scheduling shifts.')}
    </Text14>
  </Column>
);

export default PositionsEmptyState;
